import { ld } from "@/lib/theme/light-dark";
import type { ReactNode } from "react";

export function HeroVorgangSystemLog(props: {
  readonly text: string;
  readonly date: string;
}): ReactNode {
  return (
    <div
      style={{
        textAlign: "center",
        fontSize: 11,
        lineHeight: 1.45,
        color: ld("rgba(11,15,25,0.45)", "rgba(250,250,250,0.45)"),
        padding: "4px 12px",
      }}
    >
      {props.text}{" "}
      <span style={{ color: ld("rgba(11,15,25,0.38)", "rgba(250,250,250,0.38)") }}>{props.date}</span>
    </div>
  );
}
